/* ============================================================================
   MONEY, PARSED AND PUT BACK THE WAY IT CAME

   The amounts in this theme's placeholder settings are strings the owner typed
   — "49,90 €" — so adding two of them means finding the number inside, doing
   the arithmetic, and printing it back with the SAME decimal mark and the SAME
   currency token in the SAME place.

   WHY NOT Intl.NumberFormat. Reformatting as en-GB turns a Czech shop's euro
   price into "€49.90", which is not what its own customers were shown a line
   above. The only safe output is the input's own shape with different digits in
   it.

   WHY NOT parseFloat DIRECTLY. "1.234,50" and "1,234.50" are the same amount
   written by two countries, and parseFloat reads the first as 1.234. Whichever
   of . or , comes LAST is the decimal mark; everything before it is grouping.

   THE BUY BOX STILL CARRIES ITS OWN COPY of these two functions, inline in
   cooper-pdp.js. This file is the home they should both share, and moving the
   buy box onto it is a change to a working checkout path that wants doing on
   its own rather than folded into a new section. Until then: if you fix a bug
   here, fix it there.
   ========================================================================= */
(() => {
  const parse = (text) => {
    if (!text) return null;
    const match = String(text).match(/(\d[\d\s., ]*)/);
    if (!match) return null;
    const raw = match[1].trim();

    const lastComma = raw.lastIndexOf(',');
    const lastDot = raw.lastIndexOf('.');
    const decimalMark =
      lastComma > lastDot ? ',' : lastDot > lastComma ? '.' : '';

    let normalised;
    if (decimalMark) {
      const cut = raw.lastIndexOf(decimalMark);
      normalised =
        raw.slice(0, cut).replace(/[^\d]/g, '') +
        '.' +
        raw.slice(cut + 1).replace(/[^\d]/g, '');
    } else {
      normalised = raw.replace(/[^\d]/g, '');
    }

    const value = Number.parseFloat(normalised);
    if (!Number.isFinite(value)) return null;

    return {
      value,
      decimalMark: decimalMark || ',',
      template: String(text),
      token: raw,
    };
  };

  /** Prints `amount` in the shape of the `like` that parse() returned. */
  const print = (amount, like) => {
    const shown = amount.toFixed(2).replace('.', like.decimalMark);
    return like.template.replace(like.token, shown);
  };

  window.CooperMoney = {parse, print};
})();
